export { default } from './noResults';
